import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserService} from '../services/user.service';
import {catchError, map, of, switchMap, take} from 'rxjs';

export const organizationAccessGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);
  const localStorageOrgId = localStorage.getItem('organization');
  if (route.queryParams['access']) {
    return of(true);
  }

  return userService.getUserOrganizationId().pipe(
    take(1),
    switchMap(id => {
      // Already known (in-app navigation, or restored from a prior session).
      if (id || localStorageOrgId) {
        return of(true);
      }
      // Fresh tab / hard refresh: the org id subject is still `undefined`
      // because the app hasn't loaded the user's companies yet. Load them
      // (which sets the org id) before deciding — otherwise we'd wrongly
      // bounce to the dashboard on a direct page load, e.g. opening
      // /phonebook in a new tab.
      return userService.getUserCompanies().pipe(
        map(resp => {
          if (resp?.organizationId || localStorage.getItem('organization')) {
            return true;
          }
          router.navigate(['']);
          return false;
        }),
        catchError(() => {
          router.navigate(['']);
          return of(false);
        })
      );
    })
  );
}
